import { createContext } from 'react';
const initialValue = {
    active: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setActive: () => { },
};
const LabelContext = createContext(initialValue);
export default LabelContext;
//# sourceMappingURL=LabelContext.js.map